"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var ParBrandsOffersLocalesListCtl = /** @class */ (function (_super) {
    __extends(ParBrandsOffersLocalesListCtl, _super);
    function ParBrandsOffersLocalesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_language_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_id; });
        _this.dk_app_language_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_title; });
        _this.dk_app_language_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_language_code; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_text = UIUtils_1.UIUtils.IProp2Str(function (o) { o.text; });
        _this.dk_preview_text = UIUtils_1.UIUtils.IProp2Str(function (o) { o.preview_text; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    ParBrandsOffersLocalesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    ParBrandsOffersLocalesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "brand offer locale with id [" + id + "] not found !";
    };
    ParBrandsOffersLocalesListCtl.prototype.LoadData = function (Key, onDone) {
        var _this = this;
        webAApi_1.ListBrandOfferLocalesByOfferIdGet.exec({ brand_partner_offer_id: Key }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_language_id: resp.list[i].app_language_id,
                    app_language_title: resp.list[i].app_language_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    app_language_code: resp.list[i].app_language_code,
                    title: resp.list[i].title,
                    text: resp.list[i].text,
                    preview_text: resp.list[i].preview_text
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsOffersLocalesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandOfferLocale.exec({
            data: {
                brand_aff_offer_id: data.brand_aff_offer_id,
                app_language_id: data.app_language_id,
                text: data.text,
                title: data.title,
                preview_text: data.preview_text
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_language_id: data.app_language_id,
                app_language_title: resp.app_language_title,
                app_language_code: resp.app_language_code,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                text: data.text,
                preview_text: data.preview_text
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    ParBrandsOffersLocalesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBrandOfferLocale.exec({
                data: {
                    brand_partner_offer_locale_id: data.key,
                    app_language_id: data.app_language_id,
                    title: data.title,
                    text: data.text,
                    preview_text: data.preview_text
                }
            }, function (resp) {
                _tmp.app_language_id = data.app_language_id;
                _tmp.app_language_title = resp.app_language_title;
                _tmp.app_language_code = resp.app_language_code;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.title = data.title;
                _tmp.text = data.text;
                _tmp.preview_text = data.preview_text;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    ParBrandsOffersLocalesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    ParBrandsOffersLocalesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandOfferLocale.exec({ data: { brand_partner_offer_locale_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return ParBrandsOffersLocalesListCtl;
}(BaseController_1.BaseController));
exports.ParBrandsOffersLocalesListCtl = ParBrandsOffersLocalesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_offers_list/ctl/ParBrandsOffersLocalesListCtl.ts
// module id = 958
// module chunks = 0